import { useForm, useStore } from '@tanstack/react-form'
import { FF, SearchInputDebounced } from 'ui/components'
import { Select } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'
import { FilterWrapper } from 'ui/temp/Filter/styles'
import { TableFilterRow } from 'ui/temp/TableFilterRow'

import { useRelationshipsReportContext } from '../../context/RelationshipsReportContext'

import * as SC from './styles'

export const Filter = () => {
  const {
    data: {
      form: { search, inApplicationProcessOnly },
      inApplicationProcessOnlyValues
    },
    routeApi
  } = useRelationshipsReportContext()

  const navigate = routeApi.useNavigate()
  const formApi = useForm({
    defaultValues: { search, inApplicationProcessOnly }
  })

  const clearForm = () => {
    formApi.reset()
    navigate({ to: '.', search: undefined, resetScroll: false, replace: true })
  }

  return (
    <FilterPanel expanded={false} isDirty={useStore(formApi.store, (s) => s.isDirty) || false} onReset={clearForm}>
      <FilterWrapper>
        <TableFilterRow>
          <SC.FilterWrapper>
            <SC.ItemWrapper>
              <formApi.Field
                name="search"
                listeners={{
                  onChange: ({ value }) => {
                    navigate({ to: '.', search: (prev) => ({ ...prev, page: 1, search: value }) })
                  }
                }}
                children={(field) => (
                  <FF field={field} label="Search" input={(inputProps) => <SearchInputDebounced {...inputProps} />} />
                )}
              />
            </SC.ItemWrapper>
            <SC.ItemWrapper>
              <formApi.Field
                name="inApplicationProcessOnly"
                listeners={{
                  onChange: ({ value }) => {
                    navigate({ to: '.', search: (prev) => ({ ...prev, page: 1, inApplicationProcessOnly: value }) })
                  }
                }}
                children={(field) => (
                  <FF
                    label="In Application Process Only"
                    field={field}
                    input={(inputProps) => (
                      <Select {...inputProps} data-qa="Active" data={inApplicationProcessOnlyValues} />
                    )}
                  />
                )}
              />
            </SC.ItemWrapper>
          </SC.FilterWrapper>
        </TableFilterRow>
      </FilterWrapper>
    </FilterPanel>
  )
}
